import { motion } from 'framer-motion';

const spring = {
	type: 'spring',
	stiffness: 700,
	damping: 30,
};

export const Switch = ({ onToggle, isOn, disabled = false }: any) => {
	const toggleSwitch = () => {
		if (disabled) return;

		const newToggleState = !isOn;

		if (onToggle) {
			onToggle(newToggleState);
		}
	};

	return (
		<div
			className={`switch ${disabled ? 'disabled' : ''}`}
			data-ison={isOn}
			onClick={toggleSwitch}
		>
			<motion.div className='handle' layout transition={spring} />
		</div>
	);
};
